import React from "react";
import Link from "next/link";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./instruction_gallery.module.scss";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import InstructionGalleryCard from "@modules/study/common/instruction_gallery_card";

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <FiChevronRight
      className={`${className} InstructionGallerySliderNext`}
      onClick={onClick}
    />
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <FiChevronLeft
      className={`${className} InstructionGallerySliderPrev`}
      onClick={onClick}
    />
  );
}

export const InstructionGallery = (props) => {
  const settings = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    centerPadding: "60px",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: true,
          dots: false,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className={styles.section_instruction_gallery}>
      <div className="container">
        <div className={`${styles.title_wrapper}`}>
          <h2 className={`${styles.title}`}>{props.heading}</h2>
          <p className={`${styles.sub_title} sub_title`}>
            {props.shortDescription}
          </p>
        </div>

        <div className={`instructioin-video-slider`}>
          <Slider {...settings}>
            <InstructionGalleryCard />
            <InstructionGalleryCard />
            <InstructionGalleryCard />
            <InstructionGalleryCard />
            <InstructionGalleryCard />
            <InstructionGalleryCard />
            <InstructionGalleryCard />
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default InstructionGallery;
